import { HttpHandler, HttpProgressEvent, HttpInterceptor, HttpSentEvent, HttpHeaderResponse, HttpUserEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, timeout } from 'rxjs';

const DEFAULT_TIMEOUT_MS = 30000;

@Injectable()
export class CustomHttpInterceptorService implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    const startedAt = Date.now();
    const nextReq = req.clone({
      headers: req.headers
        .set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache')
        .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
        .set('If-Modified-Since', '0'),
    });

    return next.handle(nextReq).pipe(
      timeout(DEFAULT_TIMEOUT_MS),
      catchError((err) => {
        if (err?.name === 'TimeoutError') {
          console.error('[HTTP TIMEOUT]', {
            method: nextReq.method,
            url: nextReq.urlWithParams,
            ms: Date.now() - startedAt,
          });
        }
        throw err;
      })
    );
  }
}
